import feedbacks from './feedback';
import comments from './comment';
import answers from './answer';

export default {
  feedbacks,
  comments,
  answers
};
